<template>
	<div>
		<Loader :show="loading" type="inline" />
		<div v-if="!loading">
			<div
				class="box mb-2"
				v-for="(membership, index) in memberships"
				:key="index"
				:class="{ selected: membership.selected }"
			>
				<div class="group row">
					<div>
						<div class="check-circle" :class="{ selected: membership.selected }"></div>
					</div>
					<div class="flex-grow-1">
						<h5>{{ membership.name }}</h5>
					</div>
					<div class="col-md-4">
						<div>
							<b-progress :value="membership.soldPercent" :max="100" height="8px"></b-progress>
						</div>
						<div>{{ membership.sold }} de {{ membership.limit }} vendidas</div>
					</div>
					<div class="d-flex justify-content-end" v-if="event.canEdit">
						<b-dropdown no-caret right class="btn-dropdown-dots ml-2">
							<template v-slot:button-content><i class="icon icon-dot-3"></i></template>
							<b-dropdown-item @click="select(index)">
								<span v-if="!membership.selected">Habilitar acceso</span>
								<span v-if="membership.selected">Inhabilitar acceso</span>
							</b-dropdown-item>
						</b-dropdown>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import gql from "graphql-tag"

export default {
	name: "EventMemberships",
	props: {
		eventId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			item: null,
			memberships: [],
			event: {},
			loading: true
		}
	},
	async beforeMount() {
		this.loading = true
		await this.fetchData()
		await this.load()
		this.loading = false
	},
	methods: {
		select(index) {
			this.$dialog
				.confirm(
					{
						title: this.memberships[index].selected
							? "Inhabilitar acceso al evento"
							: "Habilitar acceso al evento",
						body: this.memberships[index].selected
							? `¿ Estás seguro que deseas inhabilitar el acceso al evento de la membresía ${this.memberships[index].name} ?`
							: `¿Deseas habilitar el acceso al evento de la membresía ${this.memberships[index].name} ?`
					},
					{
						okText: this.memberships[index].selected ? "Inhabilitar" : "Habilitar"
					}
				)
				.then(() => {
					this.memberships[index].selected = !this.memberships[index].selected
					this.save()
				})
		},

		async load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								membershipTypes {
									id
									name
									sold
									soldPercent
									limit
								}
								canEdit
							}
						}
					`,
					variables: { id: this.eventId },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					if (data.event && data.event.membershipTypes) {
						this.event = data.event
						data.event.membershipTypes.forEach((membership) => {
							this.memberships.find((item) => {
								if (item.id == membership.id) {
									item.selected = true
								}
							})
						})
					}
				})
				.catch(() => {})
		},

		async fetchData() {
			return this.$apollo
				.query({
					query: gql`
						query($status: String) {
							membershipTypes(status: $status) {
								data {
									id
									name
									sold
									soldPercent
									limit
									validAt
								}
							}
						}
					`,
					fetchPolicy: "no-cache",
					variables: {
						status: "all"
					}
				})
				.then(({ data }) => {
					this.memberships = data.membershipTypes.data.map((e) => {
						return {
							...e,
							selected: false,
							validAtFormatted: this.$moment(e.validAt).format("dddd DD [de] MMM YYYY [a las] HH:mm")
						}
					})
					return data.memberships
				})
				.catch(() => {})
		},

		async save() {
			let data = {
				membershipTypes: this.memberships.filter((e) => e.selected).map((e) => e.id)
			}
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: EventInput!) {
							eventUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.eventId,
						data
					}
				})
				.then(() => {
					this.$toast.success("Cambios guardados correctamente")
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.box {
	padding: 18px 16px;
	flex-direction: column;
	cursor: pointer;

	&:hover {
		background: #f2f2f2;
	}
	&.selected {
		border-color: #007bff;

		.round {
			background: #007bff;
		}
	}

	.group {
		width: 100%;
		display: flex;
		margin: 0px;
		align-items: center;
		color: #000;

		& > div {
			padding: 0px 6px;
		}
		.main-total {
			font-size: 1.2rem;
			text-align: right;
		}
	}
}
</style>
